import React from 'react';
import { Alert, Checkbox, List, ListItem, ListItemIcon, ListItemText, Paper, Stack, Typography } from '@mui/material';

export type FWizardChecklistItem = {
  code: string;
  label: string;
  description?: string;
  checked: boolean;
  severity?: 'info' | 'success' | 'warning' | 'error';
};

type Props = {
  title?: string;
  subtitle?: string;
  items: FWizardChecklistItem[];
};

class FWizardChecklist extends React.PureComponent<Props> {
  render() {
    const items = this.props.items || [];
    const blockers = items.filter((x) => !x.checked && (x.severity === 'error' || x.severity === 'warning')).length;

    return (
      <Paper elevation={0} variant="outlined" sx={{ p: 2 }}>
        <Stack spacing={1.5}>
          {(this.props.title || this.props.subtitle) && (
            <div>
              {this.props.title && <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>{this.props.title}</Typography>}
              {this.props.subtitle && <Typography variant="body2" color="text.secondary">{this.props.subtitle}</Typography>}
            </div>
          )}

          {blockers > 0 && (
            <Alert severity="warning">{blockers} requirement(s) still need attention.</Alert>
          )}

          <List dense>
            {items.map((x) => (
              <ListItem key={x.code}>
                <ListItemIcon>
                  <Checkbox edge="start" checked={x.checked} tabIndex={-1} disableRipple />
                </ListItemIcon>
                <ListItemText
                  primary={x.label}
                  secondary={x.description}
                  primaryTypographyProps={{ fontWeight: 700 }}
                />
              </ListItem>
            ))}
          </List>
        </Stack>
      </Paper>
    );
  }
}

export default FWizardChecklist;
